<app-window [title]="title" >
    <form role="form" id="detailForm">
        <div class="row">
            <div class="col-lg-6">
                <div class="form-group form-group-sm">
                    <label>Nome gruppo</label>
                    <input type="text" class="form-control form-control-sm" placeholder="..." name="title"  [(ngModel)]="record.name" >
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group form-group-sm">
                    <label>Tabella</label>
                    <app-selecttables [name]="'table'" [value]="record.table" [show_all]="false" (onchange)="record.table=$event;"></app-selecttables>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="form-group form-group-sm">
                    <label>Filtro di ricerca</label>
                    <input type="text" class="form-control form-control-sm"  placeholder="..." name="args"  [(ngModel)]="record.args" >
                </div>
            </div>            
        </div>
        <div class="row">
            <div class="col-12">               
                <button type="button" class="btn btn-outline-primary my-3 btn-block" (click)="getUsersByIdList()"><i class="fas fa-eye mr-2"></i>Visualizza anagrafiche</button>

                <div class="alert alert-info" *ngIf="showNoUser">
                    Nessuna anagrafica trovata con i criteri impostati
                </div>

                <table class="table table-sm table-striped" *ngIf="listUsers.length>0">
                    <thead>
                        <th>ID</th>
                        <th>Anagrafica</th>
                        <th>Utente</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let u of listUsers">
                            <td>{{u.id}}</td>
                            <td>{{u.name}}</td>
                            <td>{{u.username}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </form>
    <app-toolbarmodel [model]="this" [showSaveAndClose]="true"></app-toolbarmodel>
</app-window>